import { render, staticRenderFns } from "./AgencyList.vue?vue&type=template&id=364dfe36&scoped=true&"
import script from "./AgencyList.vue?vue&type=script&lang=js&"
export * from "./AgencyList.vue?vue&type=script&lang=js&"
import style0 from "./AgencyList.vue?vue&type=style&index=0&id=364dfe36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364dfe36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardTitle,VChip,VDataTable,VIcon,VSpacer,VTextField,VTooltip})
